<template>
  <q-page padding>
    <q-form
      class="row justify-center"
      @submit.prevent="handleRegister"
    >
      <h5 class="col-12 text-center">Cadastro</h5>
      <div class="col-md-4 col-sm-6 col-xs-10  q-gutter-y-md">
        <q-input
          v-model="form.name"
          label="Nome *"
          lazy-rules
          :rules="[
          val => val && !!val || 'Nome é um campo obrigatório!',
          val => val && val.length > 3 || 'Favor informe um nome valido!']
          "
        >
          <template v-slot:prepend>
            <q-icon name="person" />
          </template>
        </q-input>
        <q-input
          v-model="form.email"
          label="Email"
          type="email"
          lazy-rules
          :rules="[ val => val && val.length > 0 || 'Favor informe um email valido!']"
        >
          <template v-slot:prepend>
            <q-icon name="mail" />
          </template>
        </q-input>
        <q-input
          v-model="form.password"
          label="Senha"
          :type="isPwd ? 'password' : 'text'"
          lazy-rules
          :rules="[ val => val && val.length >= 8 || 'Favor informe uma senha com no mínimo 8 caracteres!']"
        >
          <template v-slot:prepend>
            <q-icon name="lock" />
          </template>
          <template v-slot:append>
            <q-icon
              :name="isPwd ? 'visibility_off' : 'visibility'"
              class="cursor-pointer"
              @click="isPwd = !isPwd"
            />
          </template>
        </q-input>
        <div
          class="g-recaptcha"
          data-sitekey="6LdkwCMeAAAAAKuGHbRLGqNDCnYCW-1HDvsWRrjB"
        ></div>
        <q-checkbox
          v-model="form.newsletter"
          label="Concordo receber newsletter"
        />
        <q-checkbox
          v-model="form.politicaPrivacidade"
          label="Concordo com a Política de Privacidade do Só Frases e que a minha informação pessoal seja guardada com a finalidade de criar um perfil, para publicar frases e pensamentos"
        />
        <p>Para saber mais consulte a nossa <a href="/politica-privacidade">Política de Privacidade</a>.</p>
        <div class="full-width q-mt-md">
          <q-btn
            label="Cadastrar"
            class="full-width"
            color="primary"
            type="submit"
            icon="save"
          />
        </div>
        <div class="full-width">
          <q-btn
            label="Voltar"
            class="full-width"
            flat
            :to="{name: 'home'}"
            icon="arrow_back"
          />
        </div>
      </div>

    </q-form>

  </q-page>
</template>
<script>
import { defineComponent, ref } from 'vue'
import useAuthUser from '../composables/UseAuthUser'
import { useRouter } from 'vue-router'
import useNotify from '../composables/UseNotify'

export default defineComponent({
  name: 'PageRegister',

  setup () {
    const router = useRouter()

    const { register } = useAuthUser()

    const { notifyError, notifySuccess } = useNotify()

    const form = ref({
      name: '',
      email: '',
      password: '',
      politicaPrivacidade: false,
      newsletter: false
    })

    const isPwd = ref(true)

    const handleRegister = async () => {
      try {
        await register(form.value)
        notifySuccess('Cadastro realizado com sucesso!')
        router.push({ name: 'email-confirmation', query: { email: form.value.email } })
      } catch (error) {
        notifyError(error.message)
      }
    }

    return { form, isPwd, handleRegister }
  }
})
</script>
